import { Component } from 'react';
import { Router } from '../../configs/routes';
import tablestyles from '../../styles/common/table.scss';
import FundAvatarNew from './fundAvatarNew';
class SuggestRelatedFundsNew extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      fundList: [],
    };
  }

  public async componentDidMount() {
    // filter by is hardcode as of now, can be made dynamic by passing it as prop
  }
  private handleRowClick = (fund: any) => {
    const { slug, parentSlug, isinCode, planType = 'GROWTH' } = fund;
    const href = `/mutual-funds/${parentSlug}/${slug}/${isinCode}?ref=related-funds-mf&planType=${planType}`;
    Router.pushRoute(href, href, { shallow: true });
  };
  private renderFundList = () => {
    const { fundList, isMobile } = this.props;
    return (
      <div className={tablestyles['sm-overflow-scroll']}>
        <table className="lil-border-separate lil-border-sm lil-w-full lil-shadow-sm  lil-rounded-xl lil-border-spacing-0 lil-border-grey-300 lil-mt-5">
          <thead>
            <tr className={tablestyles['bg-light-blue']}>
              <th className="lil-text-left lil-text-s-14 sm:lil-text-s-12 lil-text-font-200 lil-font-semibold lil-p-4 sm:lil-px-2">
                Fund
              </th>
              <th className="lil-text-left lil-text-s-14 sm:lil-text-s-12 lil-text-font-200 lil-font-semibold lil-p-4 sm:lil-hidden">
                NAV
              </th>
              <th className="lil-text-left lil-text-s-14 sm:lil-text-s-12 lil-text-font-200 lil-font-semibold lil-p-4 sm:lil-px-2">
                3yr Returns
              </th>
              <th className="lil-text-left lil-text-s-14 sm:lil-text-s-12 lil-text-font-200 lil-font-semibold lil-p-4 sm:lil-hidden">
                Risk
              </th>
            </tr>
          </thead>
          <tbody>
            {fundList.map((fundItem, index) => (
              <tr
                key={fundItem.productId}
                className={`lil-cursor-pointer ${tablestyles['hover-affect']}`}
                onClick={() => this.handleRowClick(fundItem)}
              >
                <td
                  className={`${
                    index !== fundList.length - 1 && 'lil-border-b-sm'
                  } lil-border-grey-250 lil-p-5 lil-pl-4`}
                >
                  <FundAvatarNew
                    imageValign="sub"
                    fundItem={{
                      fundName: fundItem.name,
                      imageUrl: fundItem.image,
                      fundMetaData: {
                        parentSlug: fundItem.parentSlug,
                        slug: fundItem.slug,
                        isinCode: fundItem.isinCode,
                      },
                      subTitle: fundItem.category,
                    }}
                    columnWidth={isMobile ? 200 : 400}
                    source={`top-funds-${fundItem.productId}`}
                    hideSubTitle={false}
                    subTitleClass={
                      'lil-text-s-14 lil-font-semibold lil-text-font-200'
                    }
                    width={12}
                  />
                </td>
                <td
                  className={`${
                    index !== fundList.length - 1 && 'lil-border-b-sm'
                  } lil-border-grey-250 lil-p-5 sm:lil-text-s-14 lil-font-medium sm:lil-hidden`}
                >
                  {Number(fundItem.nav).toFixed(2)}
                </td>
                <td
                  className={`${
                    index !== fundList.length - 1 && 'lil-border-b-sm'
                  } lil-border-grey-250 lil-p-5 sm:lil-px-2 sm:lil-text-s-14 lil-font-medium`}
                >
                  {!fundItem.return3Y ? '--' : `${fundItem.return3Y}%`}
                </td>
                <td
                  className={`${
                    index !== fundList.length - 1 && 'lil-border-b-sm'
                  } lil-border-b-sm lil-border-grey-250 lil-p-5 sm:lil-hidden lil-font-medium`}
                >
                  {fundItem.risk}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };
  public render() {
    return this.renderFundList();
  }
}

export default SuggestRelatedFundsNew;



// WEBPACK FOOTER //
// ./components/common/suggestRelatedFundsNew.tsx